var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainSendButtonmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.638 5.135C5.88 4.757 5 5.205 5 6.077V9.8c0 .682.515 1.254 1.194 1.326l5.472.576c.358.037.358.559 0 .596l-5.472.576A1.333 1.333 0 005 14.2v3.616c0 .871.88 1.444 1.638 1.065l11.715-6.015c.863-.43.863-1.318 0-1.748L6.638 5.135zM18.117 2.257a.4.4 0 01.766 0l.496 1.632a1.1 1.1 0 00.732.732l1.632.496a.4.4 0 010 .766l-1.632.496a1.1 1.1 0 00-.732.732l-.496 1.632a.4.4 0 01-.766 0l-.496-1.632a1.1 1.1 0 00-.732-.732l-1.632-.496a.4.4 0 010-.766l1.632-.496a1.1 1.1 0 00.732-.732l.496-1.632z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSendButtonmin);
export default __webpack_public_path__ + "static/media/main-send-button.min.dc5b770403b6a3fec99c4bca7fd73a22.svg";
export { ForwardRef as ReactComponent };